import { Grid } from '@mui/material'
import PageHeader from '@Components/Pages/PageHeader/PageHeader'
import '../firearm/firearm.scss'
import Firearm from '../firearm/firearm'

function Dashboard() {
    return (
        <div>
            <PageHeader title="Dashboard" />
            <Firearm />
        </div>
    )
}

export default Dashboard
